import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { useState } from 'react'
import styled from 'styled-components'

import type { SupportContact } from '@/lib/apollo/query/get-applicant'
import { formatDate, parseDate } from '@/utils/date'
import { safelyOpenLink } from '@/utils/helpers'

export interface Props {
  supportContacts: SupportContact[]
}

const Container = styled.div`
  padding: 5px;
  position: relative;
  z-index: 10;
  background: #fff;
  width: 100%;
  &:hover {
    cursor: pointer;
  }
  overflow-x: hidden;
`

const TableContainer = styled.div`
  padding: 5px 15px;
`

const ToggleArea = styled.div`
  display: flex;
  justify-content: space-between;
  img {
    transform: rotate(270deg);
  }
`

export const SupportContactsPanel = ({ supportContacts }: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Container>
      <ToggleArea onClick={() => setIsOpen(!isOpen)}>
        <h2>Salesforce History</h2>
        <img
          src="/assets/svg/collapse.svg"
          style={{ transform: `${isOpen ? 'rotate(90deg)' : ''}` }}
          alt=""
        />
      </ToggleArea>
      {isOpen && (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography variant="subtitle2">Date / Time</Typography>
                </TableCell>
                <TableCell align="right" width={150}>
                  &nbsp;
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {supportContacts.length === 0 && (
                <TableRow>
                  <TableCell align="center" colSpan={2}>
                    <Typography>No support contacts found</Typography>
                  </TableCell>
                </TableRow>
              )}
              {supportContacts.map(contact => (
                <TableRow key={contact.id}>
                  <TableCell component="th">
                    <Typography>
                      {formatDate(parseDate(contact.createdAt), 'dd/MM/yyyy HH:mm')}
                    </Typography>
                  </TableCell>
                  <TableCell align="right" padding="none">
                    <Button
                      size="small"
                      variant="text"
                      onClick={() => {
                        safelyOpenLink(contact.link)
                      }}
                      sx={{ whitespace: 'noWrap' }}
                    >
                      View in Salesforce
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Container>
  )
}
